import { ClientSubscriber } from "@avenueops/shared-types";
import { Badge } from "@avenueops/web-components";
import { PencilIcon } from "@heroicons/react/24/outline";
import { mapSubscriberTypeToLogo } from "components/integrations/utils";
import { generateLogo, generateSvg, shortenSubscriberName } from "components/signals/processPage/SubscriberListItem";
import UpdateSubscriberModal from "components/signals/processPage/UpdateSubscriberModal";
import React, { useState } from "react";

interface Props {
  subscriber: ClientSubscriber;
}

export default function SubscriberPillItem({ subscriber }: Props): JSX.Element {
  const shortenedSubscriberName = shortenSubscriberName(subscriber);
  const subscriberTypeLogo = mapSubscriberTypeToLogo(subscriber.type ?? undefined) ? generateLogo(subscriber) : generateSvg(subscriber);

  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <Badge size="SMALL">
        <div className="group flex flex-row gap-1 items-center">
          <div className="h-4 w-4">{subscriberTypeLogo}</div>
          <div className="text-sm font-medium leading-5 text-gray-800 pb-0.5 flex flex-row items-center">
            {subscriber.outboundMessage?.permalink ? (
              <a href={`${subscriber.outboundMessage?.permalink}`}>{subscriber.name}</a>
            ) : (
              <div className="font-medium"> {shortenedSubscriberName}</div>
            )}
            <div className="w-5 h-4">
              <PencilIcon className="hidden group-hover:block w-4 h-4 ml-2" onClick={() => setModalVisible(true)} />
            </div>
          </div>
        </div>
      </Badge>

      {modalVisible && <UpdateSubscriberModal setModalVisible={setModalVisible} modalVisible={modalVisible} subscriber={subscriber} />}
    </>
  );
}
